import { Helper } from '../../Helper';
export class ConcatBufferHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitPushBuffer(node, Buffer.from([]));
        sb.emitHelper(node, options, sb.helpers.arrReduce({
            withIndex: false,
            each: (innerOptions) => {
                sb.emitOp(node, 'SWAP');
                sb.emitHelper(node, innerOptions, sb.helpers.unwrapBuffer);
                sb.emitOp(node, 'CAT');
            },
        }));
    }
}

//# sourceMappingURL=ConcatBufferHelper.js.map
